export default __webpack_public_path__ + "static/8jo0509_A-88550c2792be0f1f28878f98402f9daa.mp4";